module.exports = __webpack_public_path__ + "img/like.a8162b9b.svg";